import { render, staticRenderFns } from "./MessageBulletEditor.vue?vue&type=template&id=407d6680&scoped=true&"
import script from "./MessageBulletEditor.vue?vue&type=script&lang=js&"
export * from "./MessageBulletEditor.vue?vue&type=script&lang=js&"
import style0 from "./MessageBulletEditor.vue?vue&type=style&index=0&id=407d6680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d6680",
  null
  
)

export default component.exports